module.exports = __webpack_public_path__ + "static/img/bg.26c47e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/PayDetail/images/bg.png
// module id = ndQU
// module chunks = 169